export default __webpack_public_path__ + "static/media/abeer-1.e8ebe85d.png";